
//===========================================
// THIS FILE IS AUTO-GENERATED FROM TEMPLATE. DO NOT EDIT IT DIRECTLY, INSTEAD EDIT THE CORRESPONDING FILE IN packages/template
//===========================================
export const getCookie = undefined;
export const getCookies = undefined;
export const setCookie = undefined;
export const deleteCookie = undefined;
export const getRequestHeader = undefined;
